import React from 'react'
import { useAppSelector } from 'src/app/hooks'
import { currencyListSelector } from 'src/features'
import { IntegrationPurchase } from 'src/core/models'
import styles from './IntegrationPurchaseMovileViewColumn.module.scss'
import { getFormatedPrice, getIntegrationPurchaseBuyerData } from 'src/core/helpers'
import { FormLabels, CustomText, IntegrationPurchaseCertificateColumn } from 'src/components'

const IntegrationPurchaseMovileViewColumn: React.FC<{ purchase: IntegrationPurchase }> = ({ purchase }) => {
  const owner = `${getIntegrationPurchaseBuyerData(purchase)} -(${purchase.buyer_data.email})`

  // Price
  const currencyList = useAppSelector(currencyListSelector)
  const currencyCode = currencyList.find(c => c?.symbol === purchase.currency_symbol)?.code
  const priceLabel = `${getFormatedPrice(purchase.amount, currencyCode)} - ${purchase.co2_amount} tCO₂`

  return <>
    <FormLabels
      title={purchase.name}
      subtitle={owner}
      thirdLabel={priceLabel}
    />
    <div className={styles.content}>
      <CustomText label={purchase.created} type={'secondary'} />
      <IntegrationPurchaseCertificateColumn purchase={purchase} />
    </div>
  </>
}

export default IntegrationPurchaseMovileViewColumn
